import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import { roundTimeEndDay, roundTimeEndSecond, roundTimeStartDay, roundTimeStartSecond } from "./functions";
import { createInitialPeriodState, toTimestamp } from 'store/periodState';

export const createInitialModelPeriodState = () => createInitialPeriodState({
    endSecond: roundTimeEndSecond,
});

const modelPeriodSlice = createSlice({
    name: "modelPeriod",
    initialState: createInitialModelPeriodState(),
    reducers: {
        setTimeProfileTypeId: (state, action) => {
            state.time_profile_type_id = action.payload;
        },
        setStartTimePeriod: {
            reducer: (state, action) => { state.start_time = action.payload; },
            prepare: (value) => ({ payload: toTimestamp(value) }),
        },
        setEndTimePeriod: {
            reducer: (state, action) => { state.end_time = action.payload; },
            prepare: (value) => ({ payload: toTimestamp(value) }),
        },
        setInterval: (state, action) => {
            state.interval = action.payload;
        },
        setDay: (state, action) => {
            state.day = action.payload;
        },
        setWeek: (state, action) => {
            state.week = action.payload;
        },
        setValue: {
            reducer: (state, action) => {
            state.time_profile_type_id = action.payload.time_profile_type_id;
            state.start_time = action.payload.start_time;
            state.end_time = action.payload.end_time;
            state.interval = action.payload.interval;
            state.day = action.payload.day;
            state.week = action.payload.week;
            },
            prepare: (value) => ({ payload: {
                ...value,
                start_time: toTimestamp(value.start_time),
                end_time: toTimestamp(value.end_time),
            } }),
        },
        setClearValue: (state, action) => {
            
            state.time_profile_type_id = null;
            state.start_time = null;
            state.end_time = null;
            state.interval = null;
            state.day = null;
            state.week = null;
        },
        setIsChangePeriod: (state, action) => {
            state.isChangePeriod = action.payload;
        },
        setTimeRoom: {
            reducer: (state, action) => {
                state.start = action.payload.start;
                state.end = action.payload.end;
            },
            prepare: (value) => ({ payload: {
                start: toTimestamp(value.start),
                end: toTimestamp(value.end),
            } }),
        },
        setStartTime: {
            reducer: (state, action) => { state.start = action.payload; },
            prepare: (value) => ({ payload: toTimestamp(value) }),
        },
        setEndTime: {
            reducer: (state, action) => { state.end = action.payload; },
            prepare: (value) => ({ payload: toTimestamp(value) }),
        },
        setStartTimeSecond: (state, action) => {
            state.startSecond = action.payload;
        },
        setEndTimeSecond: (state, action) => {
            state.endSecond = action.payload;
        },
        setDefaultTimeRoom: (state, action) => {
            state.start = Date.now();
            state.end = moment().add(2, 'hour').valueOf();
        },
        setStateModalDetail: (state, action) => {
            state.isOpenModalDetail = action.payload.isOpenModalDetail
            state.roomId = action.payload.roomId
        },
        setStateModalCancel: (state, action) => {
            state.isOpenModalCancel = action.payload
        },
        setCurrentTime: (state, action) => {
            state.start = moment(roundTimeStartDay()).add(roundTimeStartSecond(), 'seconds').valueOf();
            state.startSecond = roundTimeStartSecond();
            state.end = moment(roundTimeEndDay()).add(roundTimeEndSecond(), 'seconds').valueOf();
            state.endSecond = roundTimeEndSecond()
        },
    },
    extraReducers: (builder) => {
        builder.addCase('session/sessionEnded', () => createInitialModelPeriodState());
    },
});

export const {
    setTimeProfileTypeId,
    setStartTimePeriod,
    setEndTimePeriod,
    setInterval,
    setDay,
    setWeek,
    setValue,
    setClearValue,
    setIsChangePeriod,
    setTimeRoom,
    setStartTime,
    setEndTime,
    setStartTimeSecond,
    setEndTimeSecond,
    setDefaultTimeRoom,
    setStateModalDetail,
    setStateModalCancel,
    setCurrentTime
} = modelPeriodSlice.actions;
export default modelPeriodSlice.reducer;
